module.exports = __webpack_public_path__ + "static/img/1.822a416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/1.png
// module id = NDxj
// module chunks = 1